import classnames from "classnames";
import { Close } from "components/assets/Icons";
import UserInfo from "components/UserInfo";
import { forwardRef } from "react";
import getDayName, { getMonthName, padTo2Digits } from "utils/modifyDate";
import useOnClickOutside from "utils/useOnClickOutside";
import styles from "./Popup.module.scss";

const Popup = forwardRef((props, ref) => {
  const { data, setShowPopup } = props || {};
  const {
    firstName,
    lastName,
    photo,
    date,
    breaksViolation,
    scheduleEndViolation,
    scheduleStartViolation,
    break_time,
    scheduled_time,
    time_tracking,
    position,
  } = data || {};
  const dateInfo = new Date(date);

  const formatDate = (dateInfo) => {
    return `${getDayName(dateInfo, "long")}, ${padTo2Digits(
      dateInfo.getDate()
    )} ${getMonthName(dateInfo)}`;
  };

  const closeHandler = () => {
    setShowPopup(false);
  };

  useOnClickOutside(ref, closeHandler);

  return (
    <div
      ref={ref}
      className={styles.wrapper}
      style={{
        top: position.y,
        left: position.x === 0 ? "auto" : position.x,
        right: position.x === 0 ? position.x : "auto",
      }}
    >
      <span className={styles.close} onClick={closeHandler}>
        <Close />
      </span>
      <div className={styles.header}>
        <div className={styles.user}>
          <UserInfo src={photo} name={`${firstName} ${lastName}`} />
        </div>
        <div className={styles.date}>{formatDate(dateInfo)}</div>
      </div>
      <div className={styles.body}>
        <div className={styles.column}>
          <h2 className={styles.title}>Break time</h2>
          <div className={styles.table}>
            <span className={styles.label}>Min break:</span>
            <span>
              {break_time?.min !== undefined ? break_time?.min + " min" : "-"}
            </span>

            <span className={styles.label}>Max break:</span>
            <span>
              {break_time?.max !== undefined ? break_time?.max + " min" : "-"}
            </span>

            <span className={styles.label}>Actual break:</span>
            <span className={breaksViolation ? styles.highlighted : ""}>
              {break_time?.actual !== undefined
                ? break_time?.actual + " min"
                : "-"}
            </span>
          </div>
        </div>

        <div className={styles.column}>
          <h2 className={styles.title}>Scheduled time</h2>
          <div className={styles.table}>
            <span className={styles.label}>Scheduled In:</span>
            <span>{scheduled_time?.scheduled_in ?? "-"}</span>

            <span className={styles.label}>Actual In:</span>
            <span className={scheduleStartViolation ? styles.highlighted : ""}>
              {scheduled_time?.actual_in ?? "-"}
            </span>

            <span className={styles.label}>Scheduled Out:</span>
            <span>{scheduled_time?.scheduled_out ?? "-"}</span>

            <span className={styles.label}>Actual Out:</span>
            <span className={scheduleEndViolation ? styles.highlighted : ""}>
              {scheduled_time?.actual_out ?? "-"}
            </span>
          </div>
        </div>

        <div className={styles.column}>
          <h2 className={styles.title}>Time Tracking</h2>
          <table className={classnames(styles.table, styles.multicolumn)}>
            <thead>
              <tr>
                <th className={styles.label}>Clock In</th>
                <th className={styles.label}>Clock Out</th>
                <th className={styles.label}>Duration</th>
              </tr>
            </thead>
            <tbody>
              {time_tracking?.map(
                ({ clock_in, clock_out, duration }, index) => {
                  return (
                    <tr key={index}>
                      <td>{clock_in}</td>
                      <td>{clock_out}</td>
                      <td>{duration}</td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

export default Popup;
